<template>
  <div class="app-footer" :class="[{ 'is-fixed': fixed }, variantClass]">
    <div class="inner" v-if="resolvedLinks.length > 0">
      <template v-for="(link, index) in resolvedLinks" :key="link.url || link.title || index">
        <a class="footer-link" :href="link.url" target="_blank" rel="noopener noreferrer">
          {{ link.title }}
        </a>
        <span class="sep" v-if="index !== resolvedLinks.length - 1">|</span>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useConfigStore } from "@/store/configStore";

const props = defineProps({
  fixed: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: "light", // light | dark
  },
});

const configStore = useConfigStore();

const resolvedLinks = computed(() => {
  const links = configStore.links || configStore.getLinks || [];
  if (!Array.isArray(links)) return [];
  return links.filter((l) => l && l.title && l.url);
});

const variantClass = computed(() => (props.variant === "dark" ? "is-dark" : "is-light"));
</script>

<style scoped lang="less">
.app-footer {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  line-height: 20px;

  &.is-fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
  }

  &.is-light {
    color: #606266;
    background: #ffffff;
    border-top: 1px solid #ebeef5;
  }

  &.is-dark {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(0, 0, 0, 0.35);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
  }

  .footer-link {
    color: inherit;
    text-decoration: none;
  }
  .footer-link:hover {
    text-decoration: underline;
  }
  .sep {
    margin: 0 10px;
    opacity: 0.6;
  }
}
</style>

